import axiosInstance from "@/utils/axiosInstance";

const baseUrl = `api/boxes`;

const state = {};

const getters = {};

const mutations = {};

const actions = {
  getLocations({commit}, payload: {id: number, query: object}) {
    return axiosInstance.get(`${baseUrl}/${payload.id}/locations`, {params: payload?.query || {}})
    .then((data) => data.data);
  },
  getAvailableLocations({commit}, payload: {boxId: number}) {
    return axiosInstance.get(`${baseUrl}/${payload.boxId}/locations/available`)
      .then((data) => data.data);
  },
  getTags({commit}, payload: {boxId: number}) {
    return axiosInstance.get(`${baseUrl}/${payload.boxId}/tags`)
      .then((data) => data.data);
  },
  import({commit}, payload: {boxes: object[] }) {
    return axiosInstance.post(`${baseUrl}/import`, {boxes: payload.boxes})
      .then((data) => data.data);
  },
  update({commit}, payload: {id: number, box: object}) {
    return axiosInstance.put(`${baseUrl}/${payload.id}`, {box: payload.box})
      .then((data) => data.data);
  },
  updateLocationsSize({commit}, payload: {id: number, locations: object[]}) {
    return axiosInstance.put(`${baseUrl}/${payload.id}/locations-size`, {
      locations: payload.locations,
    }).then((data) => data.data);
  },
  remove({commit}, payload: {id: number}) {
    return axiosInstance.delete(`${baseUrl}/${payload.id}`)
      .then((data) => data.data);
  },
  generateBoxQrCode({commit}, payload: {id: number}) {
    return axiosInstance.put(`${baseUrl}/${payload.id}/generate-box-qrcode`, {})
      .then((data) => data.data);
  },
  deleteBoxQrCode({commit}, payload: {id: number}) {
    return axiosInstance.put(`${baseUrl}/${payload.id}/delete-box-qrcode`, {})
    .then((data) => data.data);
  },
  getPrimaryCodes({commit}, payload: {id: number}) {
    return axiosInstance.get(`${baseUrl}/${payload.id}/primary-codes`)
      .then((data) => data.data);
  },
  resetPrimaryCodes({commit}, payload: {id: number}) {
    return axiosInstance.put(`${baseUrl}/${payload.id}/primary-codes`)
      .then((data) => data.data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
